<div class="main">
  <spb-header></spb-header>
  <div class="content">
    <router-outlet></router-outlet>
  </div>
  <div [style.flex]="1"></div>
  <spb-footer
    (logoutUser)="configService.reset()"
    [license]="true"
    [token]="configService.accessToken()"
    [version]="version"
    copyrightYears="2024"
  ></spb-footer>
</div>